import { firebaseConfig as productionConfig } from "./firebase_config.production";
import { firebaseConfig as stagingConfig } from "./firebase_config.staging";

/** Vite `--mode staging` → teamops-act-staging. Any other mode (dev/production) → prod. */
export const firebaseConfig =
    import.meta.env.MODE === "staging" ? stagingConfig : productionConfig;

export const isStagingFirebase = import.meta.env.MODE === "staging";
